import React from 'react';
import useInputHelper from './inputHelper';
import { useUiTheme } from 'framework/uiTheme';
import { CommonInputLayoutProps, BaseChangeEvent, DefaultInputPropTypes } from './types';

type InputLayoutType = ReactComponent<CommonInputLayoutProps<BaseChangeEvent, Nullable<string | string[]>>>;
/**
 * Input is used for entering of text value.
 *
 * @param props.inputLabel label
 * @param props.source source
 * @param props.validationCallback called each time user selects the value
 * @param props.inputValue value to display
 * @param props.inputOnChangeCallback callback will be called when the value of component is changed *
 * @param props.isVisibleInput defined if the input should be displayed
 *
 * @returns {*}
 * @constructor
 */
const TextInput = (props: DefaultInputPropTypes<string | string[]>) => {
  const inputHelper = useInputHelper(props);
  const { InputLayout } = useUiTheme<InputLayoutType>();

  return (
    <InputLayout
      isVisible={inputHelper.isVisible()}
      label={inputHelper.getLabel()}
      source={inputHelper.getSource()}
      onChangeCallback={inputHelper.getOnChangeCallback()}
      onBlurCallback={inputHelper.getValidationCallback()}
      onFocusCallback={inputHelper.getClearValidationCallback()}
      value={inputHelper.getValue()}
      errorMessages={inputHelper.getErrorMessages()}
      isRequired={inputHelper.getIsRequired()}
      labelHint={inputHelper.getLabelHint()}
      helpText={inputHelper.getHelpText()}
      disabled={inputHelper.getIsDisabled()}
      tooltip={inputHelper.getTooltip()}
      className={inputHelper.getClassName()}
      placeholder={inputHelper.getPlaceholder()}
    />
  );
};

export default TextInput;
